import Switcher from "@components/switcher/Switcher";
import React from "react";
import PrimeLogs from "./PrimeLogs";
import PrimeOrderFlowDetails from "./PrimeOrderFlowDetails";
import PrimeUserDetails from "./PrimeUserDetails";

interface PrimeDetailsTabsProps {
  tradeId: string;
  width?: string;
}

const PrimeDetailsTabs: React.FC<PrimeDetailsTabsProps> = ({ tradeId }) => {
  const tabs = [
    {
      label: "TRADE",
      component: <PrimeOrderFlowDetails tradeId={tradeId} />,
    },
    {
      label: "USER",
      component: <PrimeUserDetails tradeId={tradeId} />,
    },
    {
      label: "LOGS",
      component: <PrimeLogs tradeId={tradeId} />,
    },
  ];

  return (
    <div className="flex flex-col gap-[12px]">
      <Switcher tabs={tabs} />
    </div>
  );
};

export default PrimeDetailsTabs;
